import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'
import router from '@/router'

export default function useZoneList(initialFetch = true) {
  const toast = useToast()

  const refZoneListTable = ref(null)

  const loadingZones = ref(false)

  const tableColumns = [
    { key: 'city' },
    { key: 'country' },
    { key: 'area' },
    { key: 'status' },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalServices = ref(1)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25]
  const tableData = ref()

  const fetchZones = params => {
    loadingZones.value = true
    store
      .dispatch('zones/fetchZones', {
        page: params?.page || undefined,
        perPage: params?.perPage || undefined,
        city: params?.city || undefined,
      })
      .then(response => {
        if (response.total) {
          totalServices.value = response.total
          tableData.value = response.data
        } else {
          totalServices.value = response.length
          tableData.value = response
        }
        loadingZones.value = false
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching Zones list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refZoneListTable.value.refresh()
  }

  function resolveZoneStatusVariant(status) {
    if (status === 'ACTIVE') return 'success'
    if (status === 'INACTIVE') return 'danger'
    return 'primary'
  }

  function goToEditZone(zone) {
    store.dispatch('zones/selectZone', zone)
    if (zone.closedAreaDetails) {
      router.push('/zones/closed/edit')
    } else {
      router.push('/zones/edit')
    }
  }

  if (initialFetch) {
    fetchZones()
  }

  return {
    fetchZones,
    refetchData,
    tableColumns,
    loadingZones,
    refZoneListTable,
    goToEditZone,
    resolveZoneStatusVariant,
    tableData,
    perPage,
    totalServices,
    currentPage,
    perPageOptions,
  }
}
